import * as angular from "angular";
import {CourseService} from "./course.service";
import {CourseSelectorComponent} from "./selector/course-selector.component";

export const CourseModule = angular.module("app.shared.course", [])

    .service("courseService", CourseService)

    .component("courseSelector", CourseSelectorComponent)

    .run(($templateCache) => {
        $templateCache.put("course-drop-down.html", require("./selector/course-drop-down.html"));
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/course/course.module.ts